export default __webpack_public_path__ + "static/media/comida_2.561543fd.svg";